const APPROVAL_STEPS = [
  {
    key: 'pjo',
    label: 'PJO',
    waitingStatus: 'Waiting for PJO Approval'
  },
  {
    key: 'hse',
    label: 'HSE',
    waitingStatus: 'Waiting for Admin HSE Approval'
  },
  {
    key: 'ktt',
    label: 'KTT',
    waitingStatus: 'Waiting for KTT Approval'
  }
];

const COURSE_TYPES = Object.freeze({
  mandatory: 'mandatory',
  development: 'development'
});

const COURSE_LABELS = Object.freeze({
  [COURSE_TYPES.mandatory]: 'Mandatory',
  [COURSE_TYPES.development]: 'Development'
});

const BASE_STATUSES = Object.freeze({
  open: 'Open',
  approved: 'Approved',
  rejected: 'Rejected',
  schedule: 'Schedule',
  noSchedule: 'No Schedule',
  cancelled: 'Cancelled',
  completed: 'Completed'
});

const WAITING_STATUS_VALUES = APPROVAL_STEPS.map(({ waitingStatus }) => waitingStatus);
const WAITING_STATUS_SET = new Set(WAITING_STATUS_VALUES);

const toSelfOptions = (items) => items.map((item) => ({ value: item, label: item }));
const hasValue = (value) => value !== undefined && value !== null && value !== '';

export const APPROVAL_STEP_SLUG = Object.fromEntries(
  APPROVAL_STEPS.map(({ key }) => [key, key])
);

export const APPROVAL_WAITING_STATUS = Object.fromEntries(
  APPROVAL_STEPS.map(({ key, waitingStatus }) => [key, waitingStatus])
);

export const APPROVAL_STEP_SLUG_OPTIONS = APPROVAL_STEPS.map(({ key, label }) => ({
  value: key,
  label
}));

export const APPROVAL_STEP_STATUS_OPTIONS = APPROVAL_STEPS.map(({ label, waitingStatus }) => ({
  value: waitingStatus,
  label
}));

export const COURSE_TYPE_OPTIONS = [
  { value: COURSE_TYPES.mandatory, label: COURSE_LABELS[COURSE_TYPES.mandatory] },
  { value: COURSE_TYPES.development, label: COURSE_LABELS[COURSE_TYPES.development] }
];

export const COURSE_TYPE_BOOLEAN_OPTIONS = COURSE_TYPE_OPTIONS.map(({ label, value }) => ({
  value: String(value === COURSE_TYPES.mandatory),
  label
}));

export const TNA_COURSE_STATUS_OPTIONS = toSelfOptions([
  BASE_STATUSES.open,
  ...WAITING_STATUS_VALUES,
  BASE_STATUSES.approved,
  BASE_STATUSES.rejected
]);

export const ENROLLMENT_COURSE_STATUS_OPTIONS = toSelfOptions([
  BASE_STATUSES.schedule,
  BASE_STATUSES.noSchedule,
  BASE_STATUSES.completed,
  BASE_STATUSES.cancelled
]);

export const PARTICIPANT_STATUS_OPTIONS = toSelfOptions([
  ...WAITING_STATUS_VALUES,
  BASE_STATUSES.approved,
  BASE_STATUSES.rejected,
  BASE_STATUSES.cancelled,
  BASE_STATUSES.completed
]);

export function waitingStatusFromApprovalStep(approvalStep) {
  if (!approvalStep) return null;
  if (APPROVAL_WAITING_STATUS[approvalStep]) {
    return APPROVAL_WAITING_STATUS[approvalStep];
  }
  return WAITING_STATUS_SET.has(approvalStep) ? approvalStep : null;
}

export function buildMitraFilterParams(filters = {}, options = {}) {
  const {
    statusKey = 'status',
    includeParticipantStatusFromApproval = false
  } = options;

  const params = {};

  if (filters.status) {
    params[statusKey] = filters.status;
  }

  if (filters.approval_step) {
    params.approval_step = filters.approval_step;
  }

  if (includeParticipantStatusFromApproval && !params.status) {
    const waitingStatus = waitingStatusFromApprovalStep(filters.approval_step);
    if (waitingStatus) {
      params.status = waitingStatus;
    }
  }

  if (hasValue(filters.course_type)) {
    params.course_type = filters.course_type;
  }

  return params;
}
